import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Form, Tabs, Upload, Button, Timeline } from 'antd';
import RichTextArea from '../../../coms/rich/RichTextArea';
import util from '../../../util/index';
import validate from '../../dev/devApply/validate';
import RichContent from '../../../coms/rich/RichContent';

const {
  checkLen,
  normFile,
  checkFileLen,
} = validate;
const {
  getFileIds,
  getAccessToken,
} = util;
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const create = Form.create;
@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys-sysManager',
  }
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '0',
    }
  }
  componentDidMount() {
    const { sysStore: { getEcology } } = this.props;
    getEcology();
  }
  componentWillUnmount() {
    this.setState({ activeKey: '0' });
  }
  onSubmit = () => {
    const { form, sysStore: { ecologyList, addEcFile, getEcology } } = this.props;
    const ecList = toJS(ecologyList);
    form.validateFields((error, values) => {
      if (!error) {
        const params = {
          desc: values.desc,
          file: getFileIds(values.file),
          version: ecList && ecList.length > 0 ? ecList[0].ec_number : '',
        };
        addEcFile(params).then(() => {
          getEcology();
        });
      }
    });
  }
  getContent = () => {
    const { activeKey } = this.state;
    const { prefixCls, form: {
      getFieldProps,
    }, sysStore: { ecologyList } } = this.props;
    return activeKey === '0' ? (
      <Form>
        <FormItem>
          <div className={`${prefixCls}-form-required`}>
            <RichTextArea {...getFieldProps('desc', {
              rules: [{ validator: checkLen }]
            })}  />
          </div>
        </FormItem>
        <FormItem>
          <div className={`${prefixCls}-form-row ${prefixCls}-form-required`}>
            <Upload
              action={`${window.server}/v1.1/sys/ecfile?access_token=${getAccessToken()}`}
              {...getFieldProps('file', {
                valuePropName: 'fileList',
                normalize: normFile,
			      		rules: [{ validator: checkFileLen },],		
              })}>
              <Button type="ghost" icon="upload">点击上传</Button>
              <span style={{ color: '#f00' }}>（文件类型：zip/rar，且必须包含ecology目录）</span>
            </Upload>
          </div>
        </FormItem>
        <FormItem>
          <Button type="primary" onClick={this.onSubmit}>发布版本</Button>
        </FormItem>
      </Form>
    ) : (
      <Timeline>
        {
          toJS(ecologyList) && toJS(ecologyList).map((data) => {
            return (
              <Timeline.Item>
                <div className={`${prefixCls}-publish-timeline-version`}>{data.ec_number.substring(0, 5)}</div>
                <div className={`${prefixCls}-publish-timeline-time`}>{data.ec_time}</div>
                <RichContent value={data.ec_log}></RichContent>
              </Timeline.Item>
            )
          })
        }
      </Timeline>
    );    
  }
  render() {
    const { activeKey } = this.state;
    const { prefixCls } = this.props;
    return (
      <div className={`${prefixCls}`}>
        <Tabs activeKey={activeKey} onChange={(key) => this.setState({ activeKey: key })}>
          <TabPane tab="待发布" key="0" />
          <TabPane tab="已发布" key="1" />
        </Tabs>
        {this.getContent()}
      </div>
    )
  }
}

Main = create()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/sysManager/Publish.js